import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const MSAL_CONFIG = {
  auth: {
    clientId: "abb9125c-d506-452b-b82f-0e168ea060ed",
    authority:
      "https://login.microsoftonline.us/4eefd5c0-419a-4da1-8d03-5c547f072f35",
    redirectUri: "https://ipcs-qa-workbench.workfinity.com",
    // redirectUri: "http://localhost:3000",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

const LOGIN_REQUEST = {
  scopes: ["openid", "offline_access"],
};

const TOKEN_REQUEST = {
  scopes: ["User.ReadWrite.All"],
};

const GRAPH_CONFIG = {
  graphUsersEndpoint: "https://graph.microsoft.us/v1.0/users",
};

const PUBLIC_CLIENT_APPLICATION = new PublicClientApplication(MSAL_CONFIG);

async function initializeMsal() {
  await PUBLIC_CLIENT_APPLICATION.initialize();
}

initializeMsal();

export {
  MSAL_CONFIG,
  LOGIN_REQUEST,
  TOKEN_REQUEST,
  GRAPH_CONFIG,
  PUBLIC_CLIENT_APPLICATION,
};
